import { YmmsDropdowns } from 'site-modules/shared/components/ymms-dropdowns/ymms-dropdowns';
import { AppraisalTabsStateContext } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/context/appraisal-tabs-context';

/**
 * V2-compatible Y/M/M/S dropdowns.
 *
 * The shared component hydrates its local fields from `context.mmy` on mount.
 * V2 keeps that state in a separate context, so this fork preserves the shared
 * dropdown behavior while binding it to the V2 state contract.
 */
export class YmmsDropdownsV2 extends YmmsDropdowns {
  static contextType = AppraisalTabsStateContext;
}
